import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { Typography } from '@mui/material';
import { GilStudentProjectReport } from '@protos/learning_management/lms.assessment.student.apis_pb';
import { GilGallery, NoEvidenceCard } from './GilGallery';
import { GilReportTable } from './GilReportTable';
import { gilText } from './gilTheme';
import { ReportTabs, SectionCard, StatusChip } from './ReportWidgets';
import {
  formatDurationBreakdown,
  formatScore,
  GalleryMedia,
  projectLabel,
} from './utils';

/** "Student analysis over this project": the one project as a table row. */
export const StudentProjectAnalysis = ({
  report,
}: {
  report?: GilStudentProjectReport;
}) => {
  //~ On a group project the group's shared lab device did the work, so the
  //~ group's time is shown as the student's own.
  const timeSpent = report?.groupWork?.timeSpent ?? report?.timeSpent;
  const {
    parts: [videoText, codingText],
    total: totalText,
  } = formatDurationBreakdown([
    timeSpent?.videoActivityBookTimeInSec ?? 0,
    timeSpent?.codingTimeInSec ?? 0,
  ]);
  return (
    <SectionCard plain subtitle="Student analysis over this project">
      <GilReportTable
        columns={[
          {
            key: 'project',
            header: 'Project Name',
            minWidth: 200,
            render: () => (
              <Typography sx={gilText(13, 600)}>
                {report?.project?.projectTitle || projectLabel(report?.project)}
              </Typography>
            ),
          },
          {
            key: 'total',
            header: 'Total Time',
            render: () => totalText,
          },
          {
            key: 'video',
            header: 'Resources',
            render: () => videoText,
          },
          {
            key: 'coding',
            header: 'Coding',
            render: () => codingText,
          },
          {
            key: 'status',
            header: 'Status',
            render: () => <StatusChip status={report?.status} />,
          },
          {
            key: 'score',
            header: 'Project Score',
            render: () => formatScore(report?.projectScore),
          },
        ]}
        rows={[report?.project?.assessmentId ?? 0]}
        rowKey={(id) => String(id)}
      />
    </SectionCard>
  );
};

const WORK_TABS = [
  { key: 'evidence', label: 'Evidence', icon: <ImageOutlinedIcon /> },
];

/** Evidence tab of one student's project: the uploaded photos and videos. */
export const StudentProjectWorkTabs = ({
  gallery,
  galleryTitle,
  evidenceSubtitle = 'Photos and videos uploaded for this project',
}: {
  gallery: GalleryMedia[];
  galleryTitle?: string;
  evidenceSubtitle?: string;
}) => (
  <>
    <ReportTabs tabs={WORK_TABS} value="evidence" onChange={() => undefined} />
    <SectionCard plain subtitle={evidenceSubtitle}>
      {gallery.length > 0 ? (
        <GilGallery items={gallery} title={galleryTitle} />
      ) : (
        <NoEvidenceCard />
      )}
    </SectionCard>
  </>
);
